module.exports = __webpack_public_path__ + "60a4fdb20da02f574373c542b5943f7d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-es.html
// module id = 988
// module chunks = 0